import React, { Fragment } from "react";
import { useCompany } from "../../data/companies/useCompany";
import { ICompany } from "../../models/ICompany";

type IRenderProps = { company: ICompany | null };

interface RenderCompanyProps {
    companyId: number;
    render: (props: IRenderProps) => any;
};

export const RenderCompany: React.FC<RenderCompanyProps> = ({ companyId, render }) => {
    const { data: company } = useCompany(companyId);
    return (
        <Fragment>
            {render({ company })}
        </Fragment>
    );
};

